import {imageUrl} from 'common/sanity';
import theme, {breakpoint} from 'common/theme';
import {SanityGalleryData} from 'common/types';
import {motion} from 'framer-motion';
import {FC, useState} from 'react';
import Carousel, {Modal, ModalGateway} from 'react-images';
import ReactGallery from 'react-photo-gallery';
import styled from 'styled-components';
import NextImage from 'next/image';
// @ts-ignore
import colorAlpha from 'color-alpha';

const Wrapper = styled.section`
  margin-left: -${({theme}) => theme.spacing(0.5)}px;
  width: calc(100% + ${({theme}) => theme.spacing(1)}px);
  width: 100%;
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
  padding: 0 ${({theme}) => theme.spacing(1)}px;
  margin-top: ${({theme}) => theme.spacing(2 + 1.75 * 0.5)}px;
  margin-bottom: ${({theme}) => theme.spacing(1)}px;
  ${breakpoint.size('sm')`
    padding: 0 ${({theme}) => theme.spacing(2)}px;
    margin-top: ${({theme}) => theme.spacing(2)}px;
    margin-bottom: ${({theme}) => theme.spacing(2)}px;
  `}
  ${breakpoint.size('md')`
    margin-top: ${({theme}) => theme.spacing(3)}px;
    margin-bottom: ${({theme}) => theme.spacing(3)}px;
  `};
`;

const InnerWrapper = styled.div`
  margin-left: -${({theme}) => theme.spacing(0.5)}px;
  width: calc(100% + ${({theme}) => theme.spacing(1)}px);
`;

const ImageWrapper = styled(motion.div)<{
  margin: string | undefined;
  background: string | undefined;
}>`
  margin: ${({margin}) => margin}px;
  background-color: ${({background}) => background};
  cursor: pointer;
  border-radius: 5px;
  transition: opacity 200ms ease-in-out;
  overflow: hidden;
  display: inline-flex;
  &:hover {
    opacity: 0.85;
  }
`;

const Gallery: FC<SanityGalleryData> = props => {
  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const [currentImage, setCurrentImage] = useState<number>(0);
  const openGallery = (index: number) => {
    setCurrentImage(index);
    setModalOpen(true);
  };
  const toggleModal = () => setModalOpen(modalOpen => !modalOpen);
  return (
    <Wrapper>
      <InnerWrapper>
        <ReactGallery
          margin={theme.spacing(0.5)}
          photos={props.items.map(item => ({
            src:
              imageUrl(item)
                .width(600)
                .auto('format')
                .quality(60)
                .url() || '',
            background: colorAlpha(item.dominant.background, 0.4),
            blur: item.lqip,
            width: item.width,
            height: item.height,
          }))}
          renderImage={({photo, margin, index}) => (
            <ImageWrapper
              key={index}
              whileHover={{scale: 1.025}}
              whileTap={{scale: 0.975}}
              background={(photo as any).background || ''}
              margin={margin}
              onClick={() => openGallery(index)}>
              <NextImage
                src={photo.src}
                placeholder='blur'
                blurDataURL={(photo as any).blur}
                width={photo.width}
                height={photo.height}
              />
            </ImageWrapper>
          )}
        />
        <ModalGateway>
          {modalOpen ? (
            <Modal onClose={toggleModal}>
              <Carousel
                currentIndex={currentImage}
                views={props.items.map(item => ({
                  source: {
                    download:
                      imageUrl(item)
                        .width(2500)
                        .auto('format')
                        .quality(80)
                        .url() || '',
                    fullscreen:
                      imageUrl(item)
                        .width(1800)
                        .auto('format')
                        .quality(80)
                        .url() || '',
                    regular:
                      imageUrl(item)
                        .width(1200)
                        .auto('format')
                        .quality(80)
                        .url() || '',
                    thumbnail:
                      imageUrl(item)
                        .width(100)
                        .auto('format')
                        .quality(80)
                        .url() || '',
                  },
                }))}
              />
            </Modal>
          ) : null}
        </ModalGateway>
      </InnerWrapper>
    </Wrapper>
  );
};

export default Gallery;
